import { render, staticRenderFns } from "./TableSale.vue?vue&type=template&id=834dffd2"
import script from "./TableSale.vue?vue&type=script&lang=js"
export * from "./TableSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports